import React, { useState, useEffect } from "react";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { languageChange } from "../../actions/language";
import { getLanding } from "../../actions/viewinstance";
import { useDispatch } from "react-redux";
import { contextUpsert } from "../../reducers/global_contexts";
import { errormessagesClear, fetchErrorMessages } from "../../reducers/reference_errormessages";

const LanguageSelect = (props) => {
    const dispatch = useDispatch();
    const [measurement, setMeasurement] = useState(props.uomName)
    const [language, setLanguage] = useState(null)
    const [languageName, setLanguageName] = useState(props.languageName)
    const groupGuid= props.groupGuid

    useEffect(()=>{
        if (!language && languageName){
            let lang = props.LanguageOptions.find(lang => lang.LanguageTypeKeyName === languageName)
            dispatch(contextUpsert({Key:"LanguageId", Value:lang.LanguageTypeId}))
            setLanguage(lang.LanguageTypeId)
        }
    },[])
    
    const handleMeasurementChange = (e) => {
        
        setMeasurement(e.target.value)
        dispatch(contextUpsert({Key:"UnitOfMeasure", Value:e.target.value==='1743' ? '1743':"1742"}))
        
    }

    const handleLanguageChange = (e) => {
        dispatch(getLanding(groupGuid, e.target.value))
      //S  languageChange(groupGuid,e.target.value)
        let lang = props.LanguageOptions.find(lang => lang.LanguageTypeId === e.target.value)

        dispatch(contextUpsert({Key:"LanguageName", Value:lang.LanguageTypeKeyName}))
        dispatch(contextUpsert({Key:"LanguageId", Value:lang.LanguageTypeId}))
   
        setLanguage(e.target.value)
        dispatch(fetchErrorMessages({ groupGuid: localStorage.getItem('group'), languageID: e.target.value }))
    }

    useEffect(() => {
        if (!language && languageName) {
            let lang = props.LanguageOptions.find(lang => lang.LanguageTypeKeyName === languageName)
            setLanguage(lang.LanguageTypeId)
            setLanguageName(lang.LanguageTypeKeyName)
            
        }
    },[language])

    return (
        <div style={{ zoom: '.9' }}>
            <FormControl component="fieldset" variant="standard" sx={{ minWidth: 180, flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                {
                    props.LanguageOptions
                    && props.LanguageOptions.length > 1
                    &&
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={language}
                        onChange={handleLanguageChange}
                    >
                        {props.LanguageOptions.map(l => (
                             <MenuItem value={l.LanguageTypeId}>{l.LanguageTypeName}</MenuItem>
                        ))}
                    </Select>
                }
                <RadioGroup
                    row
                    aria-label="measurement"
                    name="radio-buttons-group"
                    value={measurement}
                    onChange={handleMeasurementChange}
                    sx={{}}
                >
                    <FormControlLabel value="1743" control={
                        <Radio sx={
                            {
                                color: props.settings ? props.settings['THEME COLOR'] : "primary",
                                '&.Mui-checked': {
                                    color: props.settings ? props.settings['THEME COLOR'] : "primary",
                                }
                            }
                        } />
                    }
                        label={props.MeasurementOptions.ImperialRadioButton}
                    />
                    <FormControlLabel value="1742" control={
                        <Radio sx={
                            {
                                color: props.settings ? props.settings['THEME COLOR'] : "primary",
                                '&.Mui-checked': {
                                    color: props.settings ? props.settings['THEME COLOR'] : "primary",
                                }
                            }
                        } />
                    }
                        label={props.MeasurementOptions.MetricRadioButton}
                    />
                </RadioGroup>
            </FormControl>
        </div>

    );
};

export default LanguageSelect;